<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12 text-center mt-4">
    <p-selectButton
      class="compliance-selectbutton"
      [options]="detailsViewOptions"
      [(ngModel)]="selectedDetailsView"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false" />
  </div>

  @if (selectedDetailsView === 'compliance') {
    <div class="col-span-12">
      <p-select
        [options]="COMPLIANCE_STANDARD_OPTIONS"
        [ngModel]="complianceStandard"
        styleClass="filter-dropdown"
        optionLabel="label"
        optionValue="value"
        appendTo="body" />
    </div>

    @if (!!complianceResults.length) {
      <div class="col-span-12" *ngFor="let result of complianceResults">
        <microsec-card [isNestedCard]="true" [isBordered]="true">
          <div class="flex flex-wrap items-start gap-4">
            <div class="flex items-start gap-4">
              <div>
                <i class="fas fa-rectangle-list"></i>
              </div>

              <div class="flex flex-col gap-4">
                <label class="font-bold">{{ result.label }}</label>
                <label> Target Security Level: {{ result.target }} </label>
                <label> Capability Security Level: {{ result.capability }} </label>
              </div>
            </div>

            <div
              *ngIf="result.achieved !== null && result.achieved !== undefined"
              class="custom-chip square ml-auto"
              [ngClass]="{
                green: result.achieved >= result.target,
                red: result.achieved < result.target
              }">
              Achieved Security Level: {{ result.achieved }}
            </div>
          </div>
        </microsec-card>
      </div>
    } @else {
      <div class="col-span-12">
        <div class="text-grey text-center my-8">No device compliance details available</div>
      </div>
    }
  }

  @if (selectedDetailsView === 'assessment') {
    <div class="col-span-12">
      <p-multiSelect
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        styleClass="filter-multiselect"
        [options]="assessmentTypes"
        [(ngModel)]="selectedAssessmentTypeIds"
        placeholder="All Assessment Types"
        optionLabel="name"
        optionValue="id"
        appendTo="body"
        (ngModelChange)="setAssessments()">
      </p-multiSelect>
    </div>

    @if (!!assessments.length) {
      <div class="col-span-12">
        <p-dataView
          #dv
          [rows]="PER_PAGE"
          styleClass="microsec-dashboard-dataView"
          [value]="assessments"
          [paginator]="true"
          [rowsPerPageOptions]="PER_PAGE_OPTIONS"
          [loading]="isLoading">
          <ng-template #list let-assessments>
            @for (assessment of assessments; track $index) {
              <div class="mb-4 border-0 w-full">
                <microsec-card [isNestedCard]="true" [isBordered]="true">
                  <div class="flex flex-wrap items-start gap-4">
                    <div class="flex items-start gap-4">
                      <div>
                        <i class="fas fa-clipboard-list"></i>
                      </div>

                      <div class="flex flex-col gap-4">
                        <label class="font-bold">{{ assessment.name }}</label>
                        <label>
                          {{ assessment.assessmentType?.name || 'Assessment Type ID: ' + assessment.assessment_type_id }}
                        </label>
                        <label *ngIf="!!assessment.assessment_completed_date">
                          Completed on {{ assessment.assessment_completed_date | momentPipe }}
                        </label>
                        <label class="link-blue" (click)="goToAssessmentPage(assessment)">Go to Assessment</label>
                      </div>
                    </div>

                    <div
                      class="custom-chip square ml-auto"
                      [ngClass]="{
                        green: assessment.device_result === ASSESSMENT_RESULTS.COMPLIANT,
                        orange: assessment.device_result === ASSESSMENT_RESULTS.PARTIALLY_COMPLIANT,
                        red: assessment.device_result === ASSESSMENT_RESULTS.NOT_COMPLIANT,
                        grey:
                          assessment.device_result === ASSESSMENT_RESULTS.UNANSWERED || assessment.device_result === ASSESSMENT_RESULTS.NOT_APPLICABLE
                      }">
                      {{ assessment.device_result ? ASSESSMENT_RESULT_LABELS[assessment.device_result] || assessment.device_result : '-' }}
                      •
                      {{ ((assessment.device_score || 0) * 100 | number: '1.0-0') + '%' }}
                    </div>
                  </div>
                </microsec-card>
              </div>
            }
          </ng-template>
        </p-dataView>
      </div>
    } @else {
      <div class="col-span-12">
        <div class="text-grey text-center my-8">No assessment history details available</div>
      </div>
    }
  }
</div>
